<template>
    <div class="page">
        <div class="page-wrap">
            <v-toolbar style="max-width: 900px; margin: 0 auto;">
                <v-toolbar-items>
                    <v-btn flat>На главную</v-btn>
                    <v-btn flat>Музыка</v-btn>
                    <v-btn flat>Спорт</v-btn>
                    <v-btn flat>Театр</v-btn>
                </v-toolbar-items>
                <v-spacer></v-spacer>

                <v-toolbar-items>
                    <v-btn flat v-if="cart.length" @click="cartDialog = true">
                        <v-icon>shopping_cart</v-icon>
                        Корзина
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>


            <div class="page-panel">
                <div style="width: 250px">
                    <v-select style="padding-bottom: 18px" label="Рубрикатор" :items="types" v-model="type" hide-details single-line></v-select>
                </div>

                <div style="width: 250px; margin: 0 30px;">
                    <v-select style="padding-bottom: 18px" label="Место проведения" :items="places" v-model="place" hide-details prepend-icon="map" single-line></v-select>
                </div>

                <v-flex></v-flex>
                <v-btn @click="onSearch" color="info">Поиск</v-btn>
            </div>


            <div v-if="serched" class="page-results">
                <div v-if="tours.length">
                    <div v-for="(tour, i) in tours" :key="i" class="page-results__item">
                        <div>{{tour.title}}</div>
                        <div>{{tour.date}}</div>
                        <div>
                            <span v-if="tour.count">{{tour.count}} {{ $numerate('билет:::билета:::билетов', tour.count) }} в продаже</span>
                            <span v-else>нет билетов</span>
                        </div>
                        <v-flex></v-flex>
                        <input v-if="tour.count" style="width: 80px" :max="tour.count" v-model="tour.buyCount" type="number"/>
                        <v-btn v-if="tour.count" style="margin: 0" @click="onAddToCart(tour, +tour.buyCount)" icon>
                            <v-icon>shopping_cart</v-icon>
                        </v-btn>
                    </div>
                </div>
                <div v-else>
                    По Вашему запросу нет предложений
                </div>
            </div>

        </div>

        <v-dialog v-model="alertData.show" width="500">
            <v-card>
                <v-card-title v-if="alertData.title" class="headline grey lighten-2" primary-title>{{alertData.title}}</v-card-title>
                <v-card-text>{{alertData.text}}</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click="alertData.show = false">{{alertData.ok}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="cartDialog" width="800">
            <form @submit.prevent="onSubmit">
                <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                        Оформление заказа
                    </v-card-title>
                    <v-card-text>
                        <div style="padding-bottom: 50px">
                            <v-container grid-list-md>
                                <small><span style="color: red;opacity: .9;font-style: italic;">*Обязательное поле. Вводимые Вами данные не могут являться персональными!</span></small>

                                <v-layout wrap>
                                    <v-flex xs12 sm6>
                                        <v-text-field label="Имя" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field label="Фамилия"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field label="E-mail" type="email" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-text-field label="Телефон" type="text" required></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </div>

                        <div style="padding-bottom: 50px">
                            <v-data-table :headers="[{sortable: false, text: '№'}, {sortable: false, text: 'тур'}, {sortable: false, text: 'дата'}, {sortable: false, text: 'количество билетов'}, {sortable: false}]" :items="cart" hide-actions>
                                <template slot="items" slot-scope="{item, index}">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{item.tour.title}}</td>
                                    <td>{{item.tour.date}}</td>
                                    <td>{{item.count}}</td>
                                    <td>
                                        <v-btn @click="onRemoveInCart(index)" icon>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                        </div>

                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="cartDialog = false">Закрыть</v-btn>
                        <v-btn color="green" type="submit">Оформить заказ</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-dialog>
    </div>
</template>
<script>
    import data from './data'
    import mixin from '@/web/mixin.js'

    export default {
        mixins: [mixin],
        components: {},
        data () {
            return {
                serched: false,
                type: '',
                place: '',
                tours: [],
                cart: [],
                cartDialog: false,
                types: ['Бронирование отелей', 'Автобусный тур', 'Билеты на экскурсию'],
                places: ['Италия', 'Чехия', 'Швейцария', 'Австрия', 'Испания', 'Германия', 'Польша', 'Франция', 'Нидерланды'],
                alertData: {
                    show: false,
                    title: '',
                    text: '',
                    ok: ''
                }
            }
        },
        methods: {
            onSearch () {
                if (!this.type) {
                    return this.alert({text: 'Выберите Рубрикатор'})
                }
                if (!this.place) {
                    return this.alert({text: 'Выберите Место проведения'})
                }

                this.tours = this.getTours(this.type, this.place)
                this.serched = true
            },
            onSubmit () {
                this.event('buy', {site: 'mnogobiletov.ru', cart: this.cart})
                this.cartDialog = false
                this.alert({text: 'Заказ успешно оформлен!'})
                this.cart = []
            },
            onAddToCart (tour, count) {
                if (typeof count !== 'number' || !count) {
                    return this.alert({text: 'Введите количество билетов'})
                }
                if (tour.count < count || count === 0 || count < 0) {
                    return this.alert({text: 'Вы не можете купить это количество билетов'})
                }
                tour.count -= count
                tour.buyCount = ''

                let index = this.cart.findIndex(item => (item.tour.id === tour.id))
                if (index > -1) {
                    this.cart[index].count += count
                } else {
                    this.cart.push({tour, count})
                }
                this.event('addToCart', {site: 'mnogobiletov.ru', tour, count})
                this.alert({text: 'Билеты успешно добавлены в корзину. Перейдите в корзину для оформления заказа.'})
            },
            onRemoveInCart (index) {
                let item = this.cart[index]
                item.tour.count += item.count
                this.cart.splice(index, 1)
                if (!this.cart.length) {
                    this.cartDialog = false
                }
            },
            getTours (type, place) {
                let results = []
                if (data.tours[type] && data.tours[type][place]) {
                    return data.tours[type][place]
                }
                return results
            },
            alert ({text = '', title = '', ok = 'Ок'}) {
                this.alertData.title = title
                this.alertData.text = text
                this.alertData.ok = ok
                this.alertData.show = true
            }
        },
        mounted () {
            this.event('view', {site: 'mnogobiletov.ru'})
        }
    }
</script>
<style lang="stylus" scoped>
    .warning-text {
        color: red
        opacity .9
        font-style italic
    }
    .page {
        height 100%
        min-height 100%
        background url('/images/web-assets/train.jpg') no-repeat fixed top center
        background-size cover
        position relative
        &::after {
            content ""
            z-index 2
            position absolute
            top 0
            left 0
            right 0
            bottom 0
            background-color #000
            opacity 0.5
        }
        &-wrap {
            position relative
            z-index 5
        }
    }
    .page-panel {
        max-width 900px
        margin 100px auto 50px auto
        padding 0 20px
        display flex
        align-items center
        background rgba(255, 255, 255, 0.9)
    }
    .page-results {
        max-width 900px
        margin 0 auto
        padding 20px
        margin-bottom 50px
        background #efefef

        &__item {
            display flex
            padding 15px
            background rgba(255, 255, 255, 0.9)
            margin-bottom 10px
            font-size 14px

            & > * {
                margin-right 15px

                &:nth-child(1) {
                    width 250px
                }
                &:nth-child(2) {
                    width 100px
                }
            }

            input {
                border 1px solid #efefef
                width 50px!important
                text-indent 10px
            }

        }
    }

    .cart-item {
        display flex
        padding 15px
        margin-bottom 10px
        font-size 14px

        & > * {
            margin-right 15px

            &:nth-child(1) {
                width 250px
            }
            &:nth-child(2) {
                width 100px
            }
        }
    }
</style>